import React from "react";
import { siteColors } from "../variables/colors";
import { Header } from "./Header";

export const PartnerLogos = ({ images }) => {
  const logos = images;
  return (
    <div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Header color={siteColors.purple}>OUR PARTNERS</Header>
      </div>

      <div
        className="partner-logos"
        style={{
          backgroundColor: siteColors.white,
        }}
      >
        <div className="partner-logos-content">
          {logos?.map(({ image }, i) => (
            <div key={i} className="partner-logo-wrapper">
              <div>
                <img src={image?.publicURL} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
